module.exports = __webpack_public_path__ + "static/media/exportXLSXIcon.dc1368f2.svg";